import React, { useState, useEffect } from 'react';
import logo from '../logo_blade.png';
import { auth, db } from '../services/firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { doc, getDoc, updateDoc } from 'firebase/firestore';

const ADMIN_UID = 'psJJtLPO6cVnu5Sq529xY1t1SQD3';

function AdminAprovar() {
  const [autenticado, setAutenticado] = useState(false);
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [errSenha, setErrSenha] = useState('');
  const [barbearia, setBarbearia] = useState(null);
  const [carregando, setCarregando] = useState(false);
  const [resultado, setResultado] = useState(null); // 'aprovado' | 'rejeitado'
  const [erro, setErro] = useState('');

  const params = new URLSearchParams(window.location.search);
  const id = params.get('id');

  // Se o admin já estiver logado no Firebase (ex.: veio do /admin), autentica direto.
  useEffect(() => {
    const unsub = auth.onAuthStateChanged((user) => {
      if (user && user.uid === ADMIN_UID && !autenticado) {
        setAutenticado(true);
        carregarBarbearia();
      }
    });
    return () => unsub();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  async function fazerLogin() {
    if (!email || !senha) { setErrSenha('Preencha email e senha.'); return; }
    setErrSenha('');
    try {
      const cred = await signInWithEmailAndPassword(auth, email.trim(), senha);
      if (cred.user.uid !== ADMIN_UID) {
        await auth.signOut();
        setErrSenha('Acesso não autorizado.');
        return;
      }
      setAutenticado(true);
      carregarBarbearia();
    } catch (e) {
      setErrSenha('Email ou senha incorretos.');
    }
  }

  async function carregarBarbearia() {
    if (!id) { setErro('ID não encontrado na URL.'); return; }
    setCarregando(true);
    try {
      const snap = await getDoc(doc(db, 'barbearias', id));
      if (snap.exists()) {
        setBarbearia({ id, ...snap.data() });
      } else {
        setErro('Barbearia não encontrada.');
      }
    } catch (e) {
      setErro('Erro ao carregar dados.');
    }
    setCarregando(false);
  }

  async function aprovar() {
    try {
      await updateDoc(doc(db, 'barbearias', id), { status: 'aprovado' });
      setResultado('aprovado');
    } catch (e) {
      setErro('Erro ao aprovar.');
    }
  }

  async function rejeitar() {
    try {
      await updateDoc(doc(db, 'barbearias', id), { status: 'rejeitado' });
      setResultado('rejeitado');
    } catch (e) {
      setErro('Erro ao rejeitar.');
    }
  }

  const base = {
    backgroundColor: '#111111', minHeight: '100vh',
    display: 'flex', flexDirection: 'column', alignItems: 'center',
    justifyContent: 'center', fontFamily: 'Arial, sans-serif',
    padding: '40px 24px', color: '#e8e8e8'
  };

  if (!autenticado) {
    return (
      <div style={base}>
        <img src={logo} alt="BLADE" style={{ width: '120px', marginBottom: '32px' }} />
        <h2 style={{ fontSize: '18px', fontWeight: '700', marginBottom: '6px' }}>Admin — Aprovação</h2>
        <p style={{ fontSize: '13px', color: '#8f8f8f', marginBottom: '24px' }}>Entre com o email e a senha de administrador</p>
        <input
          type="email"
          placeholder="Email"
          value={email}
          autoFocus
          onChange={e => { setEmail(e.target.value); setErrSenha(''); }}
          style={{
            width: '100%', maxWidth: '320px', padding: '14px', borderRadius: '10px',
            border: '0.5px solid #2a2a2a', backgroundColor: '#1a1a1a',
            color: '#e8e8e8', fontSize: '15px', boxSizing: 'border-box',
            outline: 'none', fontFamily: 'Arial, sans-serif', marginBottom: '10px'
          }}
        />
        <input
          type="password"
          placeholder="Senha"
          value={senha}
          onChange={e => { setSenha(e.target.value); setErrSenha(''); }}
          onKeyDown={e => e.key === 'Enter' && fazerLogin()}
          style={{
            width: '100%', maxWidth: '320px', padding: '14px', borderRadius: '10px',
            border: '0.5px solid #2a2a2a', backgroundColor: '#1a1a1a',
            color: '#e8e8e8', fontSize: '15px', boxSizing: 'border-box',
            outline: 'none', fontFamily: 'Arial, sans-serif', marginBottom: '8px'
          }}
        />
        {errSenha && <p style={{ fontSize: '12px', color: '#e24b4a', marginBottom: '8px' }}>{errSenha}</p>}
        <button onClick={fazerLogin} style={{
          width: '100%', maxWidth: '320px', backgroundColor: '#2d4a2d',
          color: '#7bc47b', border: 'none', borderRadius: '12px',
          padding: '14px', fontSize: '14px', fontWeight: '600',
          cursor: 'pointer', fontFamily: 'Arial, sans-serif'
        }}>Entrar</button>
      </div>
    );
  }

  if (resultado) {
    return (
      <div style={base}>
        <img src={logo} alt="BLADE" style={{ width: '120px', marginBottom: '32px' }} />
        <div style={{ fontSize: '48px', marginBottom: '16px' }}>{resultado === 'aprovado' ? '✅' : '❌'}</div>
        <h2 style={{ fontSize: '20px', fontWeight: '700', color: resultado === 'aprovado' ? '#7bc47b' : '#e24b4a' }}>
          Cadastro {resultado === 'aprovado' ? 'aprovado' : 'rejeitado'} com sucesso
        </h2>
        <p style={{ fontSize: '13px', color: '#8f8f8f', marginTop: '8px' }}>
          {barbearia?.nome}
        </p>
      </div>
    );
  }

  if (carregando) {
    return (
      <div style={base}>
        <img src={logo} alt="BLADE" style={{ width: '120px', opacity: 0.5 }} />
      </div>
    );
  }

  if (erro) {
    return (
      <div style={base}>
        <img src={logo} alt="BLADE" style={{ width: '120px', marginBottom: '32px' }} />
        <p style={{ color: '#e24b4a', fontSize: '14px' }}>{erro}</p>
      </div>
    );
  }

  return (
    <div style={{ ...base, justifyContent: 'flex-start', paddingTop: '40px' }}>
      <img src={logo} alt="BLADE" style={{ width: '100px', marginBottom: '24px' }} />
      <h2 style={{ fontSize: '16px', fontWeight: '700', marginBottom: '4px', color: '#e8e8e8' }}>
        Novo cadastro de barbearia
      </h2>
      <p style={{ fontSize: '12px', color: '#8f8f8f', marginBottom: '24px' }}>
        Status atual: <span style={{ color: '#c9a84c' }}>{barbearia?.status}</span>
      </p>

      <div style={{
        width: '100%', maxWidth: '400px', backgroundColor: '#181818',
        border: '0.5px solid #252525', borderRadius: '12px',
        padding: '20px', marginBottom: '24px'
      }}>
        {[
          { label: 'Responsável', valor: barbearia?.nome },
          { label: 'Telefone', valor: barbearia?.telefone },
          { label: 'Cadastrado em', valor: barbearia?.criadoEm ? new Date(barbearia.criadoEm).toLocaleString('pt-BR') : '—' },
        ].map((item, i, arr) => (
          <div key={i} style={{
            display: 'flex', justifyContent: 'space-between',
            padding: '10px 0',
            borderBottom: i < arr.length - 1 ? '0.5px solid #1e1e1e' : 'none'
          }}>
            <span style={{ fontSize: '12px', color: '#8f8f8f' }}>{item.label}</span>
            <span style={{ fontSize: '13px', color: '#ccc' }}>{item.valor || '—'}</span>
          </div>
        ))}
      </div>

      <div style={{ display: 'flex', gap: '12px', width: '100%', maxWidth: '400px' }}>
        <button onClick={rejeitar} style={{
          flex: 1, backgroundColor: 'transparent', color: '#e24b4a',
          border: '0.5px solid #4a1a1a', borderRadius: '12px',
          padding: '14px', fontSize: '14px', fontWeight: '600',
          cursor: 'pointer', fontFamily: 'Arial, sans-serif'
        }}>Rejeitar</button>
        <button onClick={aprovar} style={{
          flex: 1, backgroundColor: '#2d4a2d', color: '#7bc47b',
          border: 'none', borderRadius: '12px',
          padding: '14px', fontSize: '14px', fontWeight: '600',
          cursor: 'pointer', fontFamily: 'Arial, sans-serif'
        }}>Aprovar</button>
      </div>
    </div>
  );
}

export default AdminAprovar;
